import { render, staticRenderFns } from "./stockList.vue?vue&type=template&id=1b21cdd4&"
import script from "./stockList.vue?vue&type=script&lang=js&"
export * from "./stockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports